import { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchAccessLogReportCard from "../../../components/card/SearchAccessLogReportCard";
import AccessLogReportTable from "../../../components/table/AccessLogReportTable";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import {
  FRAccessLog,
  ExportFRAccessLogsReportForExcelPDFBody,
} from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const AccessLogReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportFRAccessLogsReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allLogs, setAllLogs] = useState<FRAccessLog[]>([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl  dark:text-white">
          {t("accessLogReport")}
        </h1>
      </BackButtonWrapper>

      <SearchAccessLogReportCard
        setAllLogs={setAllLogs}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <AccessLogReportTable
        exportBody={exportBody}
        allLogs={allLogs}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default AccessLogReport;
